// extracted by mini-css-extract-plugin
export var option = "_60-0";
export var optionCard = "_60-f";
export var optionContent = "_60-g";
export var optionIcon = "_60-i";
export var optionIconBox = "_60-h";
export var optionLabel = "_60-j";
export var optionPill = "_60-m";
export var optionPillBadge = "_60-p";
export var optionPillIcon = "_60-n";
export var optionPillLabel = "_60-o";
export var optionRadio = "_60-k";
export var optionRadioInner = "_60-l";
export var optionReveal = "_60-2";
export var optionRevealDelay0 = "_60-3";
export var optionRevealDelay1 = "_60-4";
export var optionRevealDelay10 = "_60-d";
export var optionRevealDelay11 = "_60-e";
export var optionRevealDelay2 = "_60-5";
export var optionRevealDelay3 = "_60-6";
export var optionRevealDelay4 = "_60-7";
export var optionRevealDelay5 = "_60-8";
export var optionRevealDelay6 = "_60-9";
export var optionRevealDelay7 = "_60-a";
export var optionRevealDelay8 = "_60-b";
export var optionRevealDelay9 = "_60-c";
export var optionSelected = "_60-1";